export default __webpack_public_path__ + "static/media/caabLogo.17503914.png";